import {useEffect,useState} from 'react';
import {eventService} from '../services/eventService';

// Eventos activos para las vistas públicas (carrusel y calendario).
export function useActiveEvents() {
  const [events,setEvents]=useState([]);

  useEffect(()=>{
    let cancelled=false;
    eventService.getActiveEvents()
      .then(result=>{ if (!cancelled) setEvents(result); })
      .catch(error=> console.error(error));
    return ()=>{ cancelled=true; };
  },[]);

  return events;
}
